import React, { useEffect, useState } from "react";
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { newContainer } from '../../../../redux/reducers/initialState';
import * as actions from '../../../../redux/actions/containerAction';
import { Loader } from '../../../../vibe';
import { Row, Col } from 'reactstrap';
import CorrectForm from './CorrectForm';
import { toast } from 'react-toastify';
import ContainerInfoCard from '../common/ContainerInfoCard';
import ContainerChartCard from '../common/ContainerChartCard';

const ContainerCorrectPage = ({
  containers,
  loadContainers,
  correctContainer,
  history,
  ...props
}) => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({})

  const [container, setContainer] = useState({...props.container});

  const [newAmount, setNewAmount] = useState(0);
  const [comments, setComments] = useState('');

  useEffect(() => {
    if (containers.length === 0) {
      setLoading(true);
      loadContainers()
      setLoading(false);
    }
    else {
      setContainer({...props.container});
      setNewAmount(props.container.liquid_amount);
    }
  }, [props.container])

  const handleChangeAmount = (event) => {
    const { value } = event.target;
    setNewAmount(parseFloat(value));
  }

  const handleChangeComments = (event) => {
    const { value } = event.target;
    setComments(value);
  }

  function formIsValid() {
    const errors = {};
    if (newAmount >= container.capacity)
      errors.amount = "Nowa ilość jest zbyt duża";
    if (newAmount <= container.min_level)
      errors.amount = "Nowa ilość jest zbyt mała";
    if (newAmount === container.liquid_amount)
      errors.amount = "Nowa ilość płynu musi być inna od dotychczasowej"

    setErrors(errors);
    // Form is valid if the errors object still has no properties
    return Object.keys(errors).length === 0;
  }

  function handleSave(event) {
    event.preventDefault();
    if (!formIsValid()) return;
    setSaving(true);
    correctContainer(container, newAmount, comments)
      .then(() => {
        history.goBack();
        toast.success("Korekta zbiornika zatwierdzona");
      })
      .catch(error => {
        setSaving(false);
        setErrors( { onSave: error.message });
      })
  }

  return (
    loading
      ? <Loader type="bars" />
      : (<>
        <Row>
          <Col md={{ size: 9, offset: 1 }}>
            <ContainerChartCard
              container={container}
              showNewAmount={false}
            />
          </Col>
        </Row>
        <Row>
          <Col md={{ size: 5, offset: 1 }}>
            <CorrectForm
              amount={newAmount}
              comments={comments}
              onChangeAmount={handleChangeAmount}
              onChangeComments={handleChangeComments}
              isSaving={saving}
              onSave={handleSave}
              errors={errors}
            />
          </Col>
          <Col md={4}>
            <ContainerInfoCard
              container={container}
              newAmount={newAmount}
            />
          </Col>
        </Row>
      </>)
  );
}

ContainerCorrectPage.propTypes = {
  container: PropTypes.object.isRequired,
  containers: PropTypes.array.isRequired,
  loadContainers: PropTypes.func.isRequired,
  correctContainer: PropTypes.func.isRequired
}

const mapStateToProps = (state, ownProps) => {
  const containerId = ownProps.match.params.id;
  const container = containerId && state.containers.length > 0
    ? state.containers.find(c => c.id === parseInt(containerId))
    : newContainer;
  return {
    container: container,
    containers: state.containers
  }
}

const mapDispatchToProps = {
  loadContainers: actions.loadContainers,
  correctContainer: actions.correctContainer
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContainerCorrectPage);
